/**
 * Die eine `PublicClientApplication` der App (Muster aus Axis, msalInstance.ts dort).
 * Zwei Instanzen hätten zwei getrennte Token-Caches.
 */
import { EventType, PublicClientApplication } from '@azure/msal-browser';
import type { AccountInfo } from '@azure/msal-browser';
import { msalKonfiguration } from './msalConfig';

let instanz: PublicClientApplication | undefined;

export function msalInstanz(): PublicClientApplication {
  instanz ??= new PublicClientApplication(msalKonfiguration());
  return instanz;
}

/** Einmal vor dem ersten Render (main.tsx). Erst danach dürfen Konto-Methoden laufen. */
export async function initialisiereMsal(): Promise<void> {
  const app = msalInstanz();
  await app.initialize();
  // Session aus früherem Aufruf übernehmen – sonst sähe jedes Neuladen wie ein Logout aus.
  const [konto] = app.getAllAccounts();
  if (konto) app.setActiveAccount(konto);
  // Den Redirect-Rücksprung verarbeitet MsalProvider selbst; hier nur das Konto merken.
  // Seit msal-browser v4 ist die Payload von LOGIN_SUCCESS das Konto selbst, kein AuthenticationResult.
  app.addEventCallback((event) => {
    if (event.eventType !== EventType.LOGIN_SUCCESS) return;
    const account = event.payload as AccountInfo | null;
    if (account) app.setActiveAccount(account);
  });
}
